<script>
import Dialog from "../Dialog/index.vue";
import {initPag} from "@/components/PreviewPag/index";

export default {
  name: "PreviewPag",
  components: {Dialog},
  data() {
    return {
      src: undefined,
      visible: true
    }
  },
  mounted() {
    this.$nextTick(async () => {
      if (this.src.includes('pag')) {
        await uni.showLoading({mask: false})
        await initPag('preview-pag', this.src)
        uni.hideLoading()
      }
    })
  },
  methods: {
    close() {
      this.visible = false
      uni.hideLoading()
    }
  }
}
</script>

<template>
  <Dialog v-model='visible'>
    <img class='prev-image' v-if='!this.src.includes("pag")' :src='this.src' alt=''>
    <view v-else id='preview-pag' @click='visible = false'></view>
  </Dialog>
</template>

<style scoped lang="scss" scoped>
#preview-pag {
  width: 80vw;
  height: 80vh;
  display: flex;
  align-items: center;
}

.prev-image {
  max-width: 80vw;
}
</style>
